import LayoutReports from "./LayoutReports";
import { downloadSVG } from "../../../assets/reports/SVGs";
import { SearchOutlined } from "@ant-design/icons";
import { Dropdown, Input, MenuProps, Tabs, TabsProps } from "antd";
import { useState } from "react";
import HeaderList from "../HeaderList";
import BodyList from "../BodyList";
import HeaderTable from "../HeaderTable";
import ReservationsSummary from "../tables/reservations/ReservationsSummary";
import ListOfReservations from "../tables/reservations/ListOfReservations";
import CanceledReservations from "../tables/reservations/CanceledReservations";
import { FormattedMessage } from "react-intl";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getReservationsReports } from "../../../network/Reports";
type Props = {};

const ReservationsReports = (props: Props) => {
  const [key, setKey] = useState("");
  const [page, setPage] = useState(1);
  console.log(key);
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );
  const { data, isLoading } = useQuery([queryKeys?.reports, key, page], () =>
    getReservationsReports(locationId, { type: key || "summery-booking", page })
  );
  console.log(data);

  const tabs: TabsProps["items"] = [
    {
      key: "summery-booking",
      label: (
        <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
          <FormattedMessage id="reservationsSummary" />
        </div>
      ),
      children: (
        <ReservationsSummary
          data={data}
          setPage={setPage}
          page={page}
          isLoading={isLoading}
        />
      ),
    },
    {
      key: "list-booking",
      label: (
        <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
          <FormattedMessage id="listOfReservations" />
        </div>
      ),
      children: (
        <ListOfReservations
          data={data}
          setPage={setPage}
          isLoading={isLoading}
          page={page}
        />
      ),
    },
    {
      key: "cancel-booking",
      label: (
        <div className="text-[#4f5062] w-full bg-white px-[10px] py-[10px] !rounded-[14%]">
          <FormattedMessage id="canceledReservations" />
        </div>
      ),
      children: (
        <CanceledReservations
          data={data}
          setPage={setPage}
          page={page}
          isLoading={isLoading}
        />
      ),
    },
  ];
  const onChange = (key: string) => {
    setKey(key);
  };
  return (
    <LayoutReports>
      <HeaderTable />
      <div className="reportsChild">
        <Tabs
          defaultActiveKey="1"
          items={tabs}
          onChange={onChange}
          tabBarStyle={{ margin: 0 }}
        />
      </div>
    </LayoutReports>
  );
};

export default ReservationsReports;
